import { render, staticRenderFns } from "./approval_claim_content.vue?vue&type=template&id=696f8ed8&scoped=true"
import script from "./approval_claim_content.vue?vue&type=script&lang=js"
export * from "./approval_claim_content.vue?vue&type=script&lang=js"
import style0 from "./approval_claim_content.vue?vue&type=style&index=0&id=696f8ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696f8ed8",
  null
  
)

export default component.exports